import { render, staticRenderFns } from "./ParcelProductList.vue?vue&type=template&id=4f634093&"
import script from "./ParcelProductList.vue?vue&type=script&lang=js&"
export * from "./ParcelProductList.vue?vue&type=script&lang=js&"
import style0 from "./ParcelProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports